//Dependencies
import React, { useState } from 'react';
import { Affix, Select } from 'antd';
import { useNavigate } from 'react-router-dom';
const { Option } = Select;

/* SEARCH BAR  */
const Select01 = (props) =>
{
  const navigate = useNavigate();

  const { height, markers, text, visible, width } = props; 
  const [optionList01, setOptionList01] = useState();

  if(!visible) return null;

  const onClickOption = (value) =>
  {
    navigate(`/${value}`);
  };
  
  const onSearchOption = (value) =>
  {
    let filteredData;
    if (value) 
    {
      filteredData = markers.map((d, i) => 
      {
        if(d.info.name.toLowerCase().includes(value.toLowerCase()))
        {
          return(
            <Option
              key   = {i} 
              value = {d.info.branch ? `${d.info.username}?s=${d.info.branchurl}` : `${d.info.username}`}
            >
              {d.info.branch ? `${d.info.name.toUpperCase()} - ${d.info.branch.toUpperCase()}` : `${d.info.name.toUpperCase()}`}
            </Option>
          )
        }
        else
        {
          return(
            null
          )
        }
      });

      setOptionList01(filteredData)
    } 
    else 
    {
      setOptionList01([]);
    }
  };

  return(
    <Affix
      style = 
      {{ 
        position  : "fixed", 
        top       : height * 1.1,
        left      : (window.innerWidth - width)/2 , 
        zIndex    : 1000
      }}
    >
      <Select
        className       = 'flex justify-center items-center shadow-xl'
        placeholder     = {text}        
        showArrow       = {false}
        filterOption    = {false}
        notFoundContent = {null}
        onSearch        = {(e) => onSearchOption(e)}
        onChange        = {(e) => onClickOption(e)}
        showSearch
        defaultActiveFirstOption = {false}
        style           = {{ width : width }}
      >
        {optionList01}
      </Select>     
    </Affix>
  );
}

export default Select01;